import moment from 'moment';
import { createSelector } from 'reselect';

import { WorkflowsRootState } from '../ducks.types';
import { getWorkflow } from './workflow';

export const getFlexMetricsDateRange = (state: WorkflowsRootState) =>
  state.workflow?.flexMetrics || {};

/**
 * Has the date range for the metrics changed?
 */
export const getHasMetricsDateChanged = createSelector(
  [getWorkflow, getFlexMetricsDateRange],
  (workflow, dateRange) => {
    // if these values are still loading, return false
    if (!workflow?.createdAt) return false;
    if (!dateRange?.startDate || !dateRange?.endDate) return false;

    return (
      !dateRange.startDate.isSame(moment(workflow?.createdAt), 'day') ||
      !dateRange.endDate.isSame(moment(), 'day')
    );
  },
);
